interface RawResource {
  id: string
  title: string
  link: string
}

export default function buildResourceBadges(
  resourceData: RawResource[],
  baseOmrUrl: string,
  productTitle: string,
  reviewsPDPUrlWidget: string,
) {
  const resources = resourceData.map((resource, index) => {
    return {
      id: resource.id ?? index,
      title: resource.title,
      src: baseOmrUrl + resource.link,
      link: `<a title='${productTitle}' href='${reviewsPDPUrlWidget}'><img src='${baseOmrUrl}${resource.link}' alt='OMR - Badge' width='200' /></a>`,
    }
  })
  return resources
}
